import {
    SET_BRANCH_ADMIN_USER_DETAILS,
    SET_COST_CENTER_GRID_BY_USERID,
    SET_IS_COSTCENTER_SAVED_SUCCESSFULLY,
    SET_IS_COSTCENTER_VALID_FOR_SAVE,
    SET_USER_ON_SEARCH,
    SET_IS_REMOVE_COST_CENTER_FOR_USER,
    SET_COST_CENTER_BYID_AND_ROLE
} from "./BranchAdminAccessType";

const initialState = {
    userListOnSearch: [],
    branchAdminUserDetails: null,
    costCenterGridByUserId: null,
    isCostCenterValidForSave: null,
    isCostCenterSavedSuccessfully: null,
    isRemoveCostCenterForUser: null
}

const reducer = (state = initialState, action: any) => {
    if (action.type === SET_USER_ON_SEARCH) {
        return {
            ...state,
            userListOnSearch: action.userListOnSearch,
        };
    } else if (action.type === SET_BRANCH_ADMIN_USER_DETAILS) {
        return {
            ...state,
            branchAdminUserDetails: action.branchAdminUserDetails,
        };
    } else if (action.type === SET_COST_CENTER_GRID_BY_USERID) {
        return {
            ...state,
            costCenterGridByUserId: action.costCenterGridByUserId,
        };
    } else if (action.type === SET_IS_COSTCENTER_VALID_FOR_SAVE) {
        return {
            ...state,
            isCostCenterValidForSave: action.isCostCenterValidForSave,
        };
    } else if (action.type === SET_IS_COSTCENTER_SAVED_SUCCESSFULLY) {
        return {
            ...state,
            isCostCenterSavedSuccessfully: action.isCostCenterSavedSuccessfully,
        };
    } else if (action.type === SET_IS_REMOVE_COST_CENTER_FOR_USER) {
        return {
            ...state,
            isRemoveCostCenterForUser: action.isRemoveCostCenterForUser,
        };
    } else if (action.type === SET_COST_CENTER_BYID_AND_ROLE){
        return {
            ...state,
            costCenterByIdAndRole: action.costCenterByIdAndRole,
        };
    } else {
        return state;
    }
};

export default reducer;
